import { createTheme } from "@mui/material";
import { colors } from "styles/colors";

export const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.input
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: colors.input,
              borderWidth: '2px',
            },
            '&:hover fieldset': {
              borderColor: colors.input,
              borderWidth: '2px',
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.input,
              borderWidth: '2.5px',
            },
          },
        },
      },
    },
    
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: colors.label,
          '&.Mui-focused': {
            fontWeight: 600,
            color: colors.label,
          },
        },
      },
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          '&.MuiFormGroup-row': {
            '& .MuiFormControlLabel-label': {
              color: colors.input,
            },
          },
        },
      },
    },
  },
});
